/* ==========================================================================
   HBN v4 - motion

   Scroll reveal with stagger, plus a scrolled flag on <html> for the nav.

   Design decisions worth keeping:
   - The hiding class is applied by JS, never in markup. If this file fails to
     load, nothing is hidden and the page renders static. The reverse pattern
     (hide in CSS, reveal in JS) blanks the site on any JS error.
   - Header and announcement are skipped. Animating chrome that is already in
     view on load reads as a bug, not as polish.
   - A timed failsafe reveals everything after 2.5s in case IntersectionObserver
     never fires, for example inside an odd iframe or preview context.
   ========================================================================== */

(function () {
  if (window.__hbnMotion) return;
  window.__hbnMotion = true;

  var GRIDS = '.hbn-goals, .hbn-prods, .hbn-quiz__opts, .hbn-quiz__r-prods, .hbn-ft__g';
  var SKIP = '.hbn-nav, .hbn-ann, .hbn-header-wrap';
  var MAX_STAGGER = 10;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function collect(section) {
    var out = [];
    var kids = section.querySelectorAll('.hbn-inner > *');

    Array.prototype.forEach.call(kids, function (el) {
      if (el.matches && el.matches(GRIDS) && el.children.length) {
        Array.prototype.forEach.call(el.children, function (child) { out.push(child); });
      } else {
        out.push(el);
      }
    });

    return out;
  }

  function prime(section) {
    if (section.__hbnPrimed) return;
    section.__hbnPrimed = true;

    collect(section).forEach(function (el, idx) {
      el.classList.add('hbn-r');
      el.style.setProperty('--hbn-i', String(Math.min(idx, MAX_STAGGER)));
    });
  }

  function revealAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.hbn'), function (s) {
      s.classList.add('hbn-in');
    });
  }

  function sections() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.hbn'),
      function (s) { return !s.querySelector(SKIP); }
    );
  }

  function observe() {
    var list = sections();
    if (!list.length) return;

    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hbn-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    list.forEach(function (s) {
      prime(s);
      io.observe(s);
    });

    window.setTimeout(revealAll, 2500);
  }

  function scrollFlag() {
    var root = document.documentElement;
    var ticking = false;

    function apply() {
      root.classList.toggle('hbn-scrolled', window.scrollY > 12);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });

    apply();
  }

  function start() {
    scrollFlag();
    if (reduced()) { revealAll(); return; }
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.classList && e.target.classList.contains('hbn') ? e.target : e.target.querySelector('.hbn');
    if (s) s.classList.add('hbn-in');
  });
})();
